export const REQUEST_PROGRAM_FINDER_BANNER_TEST_ID =
  'request-program-finder-banner';
